import { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

export const SignaturePad = ({ onChange }) => {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const canvas = canvasRef.current;
    canvas.width = canvas.offsetWidth * 2;
    canvas.height = canvas.offsetHeight * 2;
    const ctx = canvas.getContext("2d");
    ctx.scale(2, 2);
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#0F172A";
  }, []);

  const pos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const point = e.touches ? e.touches[0] : e;
    return { x: point.clientX - rect.left, y: point.clientY - rect.top };
  };

  const startDraw = (e) => {
    e.preventDefault();
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.lineTo(x, y);
    ctx.stroke();
    setEmpty(false);
  };

  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onChange(canvasRef.current.toDataURL("image/png"));
  };

  const clear = () => {
    const canvas = canvasRef.current;
    canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
    setEmpty(true);
    onChange("");
  };

  return (
    <div className="space-y-2">
      <div className="relative rounded-xl border-2 border-dashed border-slate-300 bg-slate-50">
        <canvas
          ref={canvasRef}
          data-testid="signature-canvas"
          className="w-full h-40 touch-none rounded-xl"
          onMouseDown={startDraw}
          onMouseMove={move}
          onMouseUp={end}
          onMouseLeave={end}
          onTouchStart={startDraw}
          onTouchMove={move}
          onTouchEnd={end}
        />
        {empty && <span className="absolute inset-0 grid place-items-center text-sm text-slate-400 pointer-events-none">Signez ici avec le doigt</span>}
      </div>
      <button type="button" data-testid="signature-clear-btn" onClick={clear} className="text-xs text-slate-500 hover:text-slate-900 flex items-center gap-1">
        <Eraser size={13} /> Effacer
      </button>
    </div>
  );
};

export default SignaturePad;
